


























































































































































import Vue from 'vue'
import moment from 'moment'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import {
  DELETE_NOTE_ATTACHMENT,
  FETCH_NOTE_ATTACHMENT_LIST,
  SAVE_NOTE_ATTACHMENT, SAVE_PRODUCT_NOTE
} from '@/store/action-types'
import _ from 'lodash'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import { SaveNoteAttachmentPayload, UpsertProduktNotizenRequest } from '@/types/payload'
import {
  DeleteNoteAttachmentResponse,
  GetNoteAttachmentListResponse, ProductNoteUpsertResponse,
  SaveNoteAttachmentResponse
} from '@/types/service-response'
import ImageGalleryDialog from '@/components/master-data/address/ImageGalleryDialog.vue'
import { ProductNoteType } from '@/model/products/ProductNoteType'
import { ProductNoteEmployee } from '@/model/products/ProductNoteEmployee'
import { ProductNote } from '@/model/products/ProductNote'

interface EventFile extends Event {
  target: HTMLInputElement & EventTarget
}

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  inSaveProgress: boolean

  title: string
  validationRules: Array<Function>
  selectedResponsibleEmployee: number | null
  dateStartIso: string
  dateEndIso: string
  alreadyDone: number
  selectedAuthor: number | null
  isPrivate: boolean
  noteType: number | null
  noteTitle: string
  noteText: string
  showImageGallery: boolean
  imageList: string[]
  imageIdList: number[]
  deleteLoading: boolean
}

export default Vue.extend({
  name: 'ProductNotesDialog',

  components: {
    ImageGalleryDialog
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    employeeList: Array as () => ProductNoteEmployee[],
    notesData: Object as () => ProductNote,
    noteTypeList: Array as () => ProductNoteType[],
    productId: Number,
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('masterData.addresses.required').toString()
    const today = new Date()
    // @ts-ignore
    const todayIso = this.formatDateIso(today)

    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      inSaveProgress: false,

      title: '',
      validationRules: [required],
      selectedResponsibleEmployee: null,
      dateStartIso: todayIso,
      dateEndIso: todayIso,
      alreadyDone: 0,
      selectedAuthor: null,
      isPrivate: false,
      noteType: null,
      noteTitle: '',
      noteText: '',
      showImageGallery: false,
      imageList: [],
      imageIdList: [],
      deleteLoading: false
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    dateStartFormatted (): string {
      const date: Date = new Date(this.dateStartIso)
      return this.formatDate(date)
    },

    dateEndFormatted (): string {
      const date: Date = new Date(this.dateEndIso)
      return this.formatDate(date)
    }
  },

  methods: {
    onFieldStartChange (): void {
      if(moment(this.dateStartIso, 'YYYY-MM-DD') > moment(this.dateEndIso, 'YYYY-MM-DD'))
      this.dateEndIso = this.dateStartIso
    },

    formatDateIso (date: Date): string {
      return moment(date).format('YYYY-MM-DD')
    },

    formatDate (date: Date): string {
      return moment(date).format('DD.MM.YYYY')
    },

    onAddImageClick (): void {
      //@ts-ignore
      this.$refs.fileInput.click()
    },

    onFileChange (e: EventFile): void {
      if (e && e.target.files) {
        const files: File | undefined = e.target.files[0]

        if (files) {
          const reader = new FileReader()

          reader.readAsDataURL(files)
          reader.onload = (e: any) => {
            if (e.target && e.target.result) {
              if(this.notesData && this.notesData.id) {
                let type: string = e.target.result.split('/')[1].split(';')[0]
                let image = e.target.result.split(',')[1]

                const payload: SaveNoteAttachmentPayload = {
                  NoteId: this.notesData.id!,
                  File: image,
                  FileExtension: type
                }

                this.saveNoteAttachment(payload)
              } else {
                this.imageList.push(e.target.result)
              }

              /*const img = new Image()
              // @ts-ignore
              img.src = e.target.result
              img.onload = () => {
                const elem = document.createElement('canvas')
                /*const scaleFactor = 200 / img.width
                elem.width = 200
                elem.height = img.height * scaleFactor*/
                /*elem.width = img.width
                elem.height = img.height
                const ctx = elem.getContext('2d')

                //ctx!.drawImage(img, 0, 0, 200, img.height * scaleFactor)
                ctx!.drawImage(img, 0, 0, img.width, img.height)
                ctx!.canvas.toBlob((blob: any) => {
                  new File([blob], 'image', {
                    //type: 'image/png',
                    lastModified: Date.now()
                  })
                }, 'image/jpeg', 1)
                this.imageList.push(elem.toDataURL('image/jpeg', 1))
              }*/
            }
          }
        }
      }
    },

    onShowImageClick (): void {
      this.showImageGallery = true
    },

    onCloseImageGalleryDialog (): void {
      this.showImageGallery = false
    },

    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onDeleteFromImageList (item: number): void {
      this.imageList.splice(item, 1)
      if(this.imageList.length === 0) {
        this.onCloseImageGalleryDialog()
      }
    },

    async onDeleteFromImageIdList (item: number): Promise<void> {
      const imageNumber: number = this.imageIdList[item]

      try {
        this.deleteLoading = true
        let response: DeleteNoteAttachmentResponse = await this.$store.dispatch(DELETE_NOTE_ATTACHMENT, imageNumber)
        this.deleteLoading = false
        if(!response.IsError && response.Deleted) {
          this.imageIdList.splice(item, 1)
          if(this.imageList.length === 0) {
            this.onCloseImageGalleryDialog()
          }
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.deleteLoading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']
      if (form.validate()) {

        const payload: UpsertProduktNotizenRequest = {
          ID: this.notesData ? this.notesData.id : 0,
          Product: this.productId,
          Art: this.noteType!,
          Erledigt: this.alreadyDone,
          Author: this.selectedAuthor!,
          Verantwortlich: this.selectedResponsibleEmployee!,
          Beginn: this.dateStartIso,
          Faellig: this.dateEndIso,
          Titel: this.noteTitle,
          Beschreibung: this.noteText,
          BeschreibungRtf: this.notesData ? this.notesData.beschreibungRTF : '',
          Privat: this.isPrivate,
          Herkunft: this.notesData ? this.notesData.herkunft : 0
        }

        this.saveNote(payload)

      }
    },

    async saveNote (payload: UpsertProduktNotizenRequest): Promise<void> {
      this.inSaveProgress = true
      try {
        let response: ProductNoteUpsertResponse = await this.$store.dispatch(SAVE_PRODUCT_NOTE, payload)
        if(!response.IsError && response.NoteId) {
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.imageList.forEach((item: string) => {
            let type: string = item.split('/')[1].split(';')[0]
            let image = item.split(',')[1]

            const payload: SaveNoteAttachmentPayload = {
              NoteId: response.NoteId,
              File: image,
              FileExtension: type
            }
            this.saveNoteAttachment(payload)
          })
          this.$emit('dialogSaved')
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.inSaveProgress = false
      }
    },

    async fetchNoteAttachmentList (): Promise<void> {
      try {
        let response: GetNoteAttachmentListResponse = await this.$store.dispatch(FETCH_NOTE_ATTACHMENT_LIST, this.notesData.id)
        if(!response.IsError) {
          if(response.Data) {
            this.imageIdList = response.Data
          }
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async saveNoteAttachment (payload: SaveNoteAttachmentPayload): Promise<void> {
      try {
        let response: SaveNoteAttachmentResponse = await this.$store.dispatch(SAVE_NOTE_ATTACHMENT, payload)
        if(!response.IsError && response.AttachmentId) {
          this.imageIdList.push(response.AttachmentId)
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    }
  },

  mounted (): void {
    if(this.notesData && this.notesData.id) {
      this.title = this.$t('masterData.addresses.editNote').toString()
      const noteData: ProductNote = _.cloneDeep(this.notesData)

      this.selectedResponsibleEmployee = noteData.responsibleEmployee
      this.dateStartIso = noteData.dateStartIso ? moment(noteData.dateStartIso, "YYYY-MM-DD HH:mm:ss").format('YYYY-MM-DD') : ''
      this.dateEndIso = noteData.dateEndIso ? moment(noteData.dateEndIso, "YYYY-MM-DD HH:mm:ss").format('YYYY-MM-DD') : ''
      this.alreadyDone = noteData.alreadyDone
      this.selectedAuthor = noteData.author
      this.isPrivate = noteData.isPrivate
      this.noteType = noteData.noteType
      this.noteTitle = noteData.noteTitle
      this.noteText = noteData.noteText

      this.fetchNoteAttachmentList()

    } else {
      this.title = this.$t('masterData.addresses.addNote').toString()
      this.selectedResponsibleEmployee = this.currentUserId
      this.selectedAuthor = this.currentUserId
    }

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  }
})
